<!--
  ~ Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
  ~ Venelin Iliev <http://veneliniliev.com>
  -->

<div class="modal-header">
  <h4 class="modal-title">
    <span *ngIf="locale">{{ 'LOCALES.LOCALES_FORM.EDIT_LOCALE' | translate }}</span>
    <span *ngIf="!locale">{{ 'LOCALES.LOCALES_FORM.ADD_LOCALE' | translate }}</span>
  </h4>
  <button type="button" class="close btn-close-templates" aria-label="Close" (click)="modal.dismiss('Cross click')">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<ng-scrollbar class="modal-body ps">
  <form id="locale-form" (ngSubmit)="save()" [formGroup]="form" novalidate>
    <div class="form-group">
      <label>{{ 'LOCALES.LOCALES_FORM.NAME' | translate }}</label>
      <input type="text" class="form-control" formControlName="name" />
    </div>
    <div class="form-group">
      <label>{{ 'LOCALES.LOCALES_FORM.LOCALE' | translate }}</label>
      <input type="text" class="form-control" formControlName="locale" />
    </div>
    <div class="form-group form-check">
      <input type="checkbox" class="form-check-input" formControlName="active" />
      <label class="form-check-label">{{ 'LOCALES.LOCALES_FORM.ACTIVE' | translate }}</label>
    </div>
  </form>
</ng-scrollbar>

<div class="modal-footer">
  <button type="submit" class="btn btn-outline-dark btn-xs" form="locale-form" [disabled]="form.invalid">
    {{ 'LOCALES.LOCALES_FORM.SAVE' | translate }}
  </button>
</div>
